import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ProdRelList } from '@/md/entities/prodRel/ProdRelList';

export const BrandProdDetail = () => {
  const { entityObj } = useEntityMgr();

  // --- Tab Specifications ---
  const tabSpecs = [
    { id: 'info', label: 'Info', content: <EntityForm /> },
    { id: 'prodRel', label: 'Relationships', content: <ProdRelList ndc11ProdId={entityObj.id} /> },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
